import NewPasswordPage from 'pages/login/newPasswordPage';
import {
  LandingPage,
  Funding,
  AppTrackFundingAdmin,
  RegisterPageConfirmation,
  Reports,
  LoginAs,
  LoginPage,
  ForgotPassword,
  ConfirmRegistration,
  PlansPage,
  UserProfileForm,
  FundingProgramDetails,
} from '../pages';
import { MainForms, AppTrackPage } from '../growth';
import { ViewForm } from '../growth/appTrack/';
import { RegisterPage } from '../pages/login';
import AdminPage from 'pages/adminPanel';
import { SubscriptionsPage } from 'pages/subscriptionsPage';
import { NotificationForm } from 'pages/notificationForm';

export const routes = [
  {
    name: 'LandingPage',
    path: '/',
    Element: LandingPage,
    privileges: ['header', 'footer'],
    requireAuth: false,
  },
  {
    name: 'LoginAs',
    path: 'loginAs',
    Element: LoginAs,
    privileges: ['header'],
    requireAuth: false,
  },
  {
    name: 'LoginPage',
    path: 'login',
    Element: LoginPage,
    privileges: ['header'],
    requireAuth: false,
  },
  {
    name: 'ForgotPassword',
    path: 'forgot-password',
    Element: ForgotPassword,
    privileges: ['header'],
    requireAuth: false,
  },
  {
    name: 'RegisterPage',
    path: 'register',
    Element: RegisterPage,
    privileges: ['header'],
    requireAuth: false,
  },
  {
    name: 'NewPassword',
    path: '/new-password',
    Element: NewPasswordPage,
    requireAuth: true,
    requirePasswordChange: true,
  },
  {
    name: 'ConfirmRegistration',
    path: 'confirm-registration',
    Element: ConfirmRegistration,
    requireAuth: true,
    requireConfirmRegistration: true,
  },
  {
    name: 'Admin',
    path: '/admin',
    Element: AdminPage,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['AdminResourceGroup', 'System_Administrator'],
  },
  {
    name: 'MainForms',
    path: '/main-forms/',
    Element: MainForms,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor', 'FundingAdminGroup'],
  },
  {
    name: 'MainForms',
    path: '/main-forms/view',
    Element: MainForms,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor', 'FundingAdminGroup'],
  },
  {
    name: 'MainForms',
    path: '/main-forms/:id',
    Element: MainForms,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor', 'FundingAdminGroup'],
  },
  {
    name: 'MainForms',
    path: '/main-forms/:id/view',
    Element: MainForms,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor', 'FundingAdminGroup'],
  },
  {
    name: 'AppTrack',
    path: 'appTrack',
    Element: AppTrackPage,
    privileges: ['header', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor', 'FundingAdminGroup'],
  },
  {
    name: 'ApptrackView',
    path: '/viewForm/:taskId',
    Element: ViewForm,
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor'],
    privileges: ['header', 'footer', 'userProfileIcon'],
  },
  {
    name: 'ApptrackView',
    path: '/viewForm/:taskId/view',
    Element: ViewForm,
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor'],
    privileges: ['header', 'footer', 'userProfileIcon'],
  },
  {
    name: 'FundingPage',
    path: 'fundingpage',
    Element: Funding,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor'],
  },
  {
    name: 'FundingProgramDetails',
    path: 'fundingpage/details/:id',
    Element: FundingProgramDetails,
    privileges: ['header', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['Beneficiary', 'Auditor'],
  },
  {
    name: 'FundingAdminPage',
    path: 'fundingadminpage',
    Element: AppTrackFundingAdmin,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['FundingAdminGroup'],
  },
  {
    name: 'RegisterPageConfirmation',
    path: 'fundingadminpage/:id',
    Element: RegisterPageConfirmation,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['FundingAdminGroup'],
  },
  {
    name: 'RegisterPageConfirmationView',
    path: 'fundingadminpage/:id/view',
    Element: RegisterPageConfirmation,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['FundingAdminGroup'],
  },
  {
    name: 'UserProfile',
    path: 'userProfileForm',
    Element: UserProfileForm,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: [
      'Beneficiary',
      'Auditor',
      'System_Administrator',
      'FundingAdminGroup',
    ],
  },
  {
    name: 'NotificationForm',
    path: 'notificationForm',
    Element: NotificationForm,
    privileges: ['header', 'footer', 'userProfileIcon'],
  },
  {
    name: 'SubscriptionsPage',
    path: 'subscriptionsPage',
    Element: SubscriptionsPage,
    privileges: ['header', 'footer', 'userProfileIcon'],
  },
  {
    name: 'PlansPage',
    path: 'plansPage',
    Element: PlansPage,
    privileges: ['header', 'footer', 'userProfileIcon'],
  },
  {
    name: 'ReportsPage',
    path: '/reports',
    Element: Reports,
    privileges: ['header', 'footer', 'userProfileIcon'],
    requireAuth: true,
    requiredGroups: ['AdminResourceGroup', 'System_Administrator'],
  },
];
